import React from "react";
import { motion } from "framer-motion";
import innovation from "../Images/innovation.png";
import culuter from "../Images/culuter.png";
import Growth from "../Images/Growth.png";
import worklife from "../Images/worklife.png";

const steps = [
  {
    id: 1,
    title: "Innovation",
    description:
      "Work on cutting-edge projects using the latest technologies and methodologies.",
    color: "bg-orange-400",
    iconImg: innovation,
    textColor: "text-orange-500",
  },
  {
    id: 2,
    title: "Collaborative Culture",
    description:
      "Join a team that values collaboration, knowledge sharing, and mutual support.",
    color: "bg-pink-500",
    iconImg: culuter,
    textColor: "text-pink-500",
  },
  {
    id: 3,
    title: "Growth Opportunities",
    description:
      "Develop your skills and advance your career through continuous learning and mentorship.",
    color: "bg-teal-400",
    iconImg: Growth,
    textColor: "text-teal-500",
  },
  {
    id: 4,
    title: "Work-Life Balance",
    description:
      "Enjoy flexible work arrangements that help you maintain a healthy work-life balance.",
    color: "bg-green-400",
    iconImg: worklife,
    textColor: "text-green-500",
  },
];

// Duplicate steps for a smooth infinite effect
const marqueeSteps = [...steps, ...steps];

export default function PartnershipModels() {
  return (
    <div className="flex flex-col items-center  py-12 overflow-hidden  text-white">
      
      {/* Heading Section */}
      <div className="p-15">
        <motion.div
          className="lg: text-left lg:text-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
        >
          <motion.button
            className="relative bg-[#432DD7] w-[178px] h-[60px] text-white font-[Nunito] rounded-full  flex justify-center items-center"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Why Join Us
          </motion.button>

          <h2 className="text-3xl lg:text-4xl relative font-[700] mt-5 text-black  " style={{ fontFamily: 'PT Sans' }}>
            Why Join Us?
          </h2>

          <p style={{ fontFamily: "Allison, sans-serif" }} className="relative text-[#432DD7] text-[40px] mt-2">
            We offer growth, innovation, and endless career opportunities.
          </p>

          <p className="text-[#62739E] relative mt-4 relative leading-relaxed text-[14px]">
            Discover why Godhani Technology is a great place to build your career. We offer a dynamic work environment, endless growth opportunities, and innovative projects. Join us to collaborate with industry experts, enhance your skills, and shape a successful future in technology. </p>

        </motion.div>
      </div>
      {/* Infinite Marquee */}
      <div className="w-full overflow-hidden relative mt-10">
        <div className="flex whitespace-nowrap animate-marquee gap-8">
          {marqueeSteps.map((step, index) => (
            <div
              key={index}
              className="min-w-[280px] md:min-w-[320px] lg:min-w-[350px] flex flex-col items-center text-center p-6 rounded-[30px] bg-[#12172b] border border-white mx-4 relative"
            >
              {/* Dots Above Cards */}
              <div className="absolute top-[-16px] left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-600 rounded-full"></div>

              {/* Colored Icon Background */}
              <div className={`w-16 h-16 flex rounded-full ${step.color}`}>
                <img src={step.iconImg} alt={step.title} className="w-16 h-16 object-contain" />
              </div>

              {/* Title with Matching Color */}
              <h3 style={{ fontFamily: 'PT Sans' }} className={`mt-4 text-left text-[24px]  font-bold ${step.textColor}`}>
                {step.title}
              </h3>

              {/* Description */}
              <p className="mt-2 leading-relaxed text-justify max-w-[280px] font-[Nunito] text-[14px] text-white break-words text-wrap text-left ">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* CSS for Infinite Marquee */}
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); } /* Moves exactly half the width */
        }
        .animate-marquee {
          display: flex;
          width: max-content; /* Ensures smooth scrolling */
          animation: marquee 10s linear infinite; /* Adjust speed as needed */
        }
      `}</style>
    </div>
  );
}
